import admin from './admin';
import operator from './operator';
import guest from './guest';

const Users = {
    install(Vue, options){
        Vue.prototype.$p = function(input){
            return getPermission(input, this.$store.getters.getUser.type);
        }

        function getPermission(input, type){
            let permissions = guest;
            switch(type){
                case 'admin':permissions = admin; break;
                case 'operator':permissions = operator; break;
                case 'guest':permissions = guest; break;
            }

            let sections = input.split('/');

            try{
                sections.forEach(section=>{
                    permissions = permissions[section];
                })
            }catch(e){
                permissions = undefined;
            }finally{
                if(permissions != undefined)
                    return permissions;
                return undefined;
            }
        }
    }
}

export default Users;


// WEBPACK FOOTER //
// ./src/users/index.js